module.exports = __webpack_public_path__ + "img/wechat.5441554e.png";